module.exports = __webpack_public_path__ + "media/images/flags/4x3/tca-f74ae43be38082fc105a1f09a012f753.svg";